var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-left w-full h-full"},[_c('vs-checkbox',{attrs:{"checked":_vm.params.data.is_default,"disabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }